module.exports = __webpack_public_path__ + "a1dae62519c0cd21b39f869c4622e251.png";